import { Injectable, Inject } from '@angular/core';
import { CookieService } from '@shared/cookie';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { Operator } from 'rxjs/Operator';
import { AUTH_CONFIG } from './auth.config';
import { AuthConfig } from './auth.interface';

export interface AuthState {
  uid: number;
  token: string;
}

@Injectable()
export class Auth extends ReplaySubject<AuthState> {
  constructor(
    @Inject(AUTH_CONFIG) private authConfig: AuthConfig,
    private cookies: CookieService,
  ) {
    super(1); // Replay last
    const uid = parseInt(this.cookies.get(this.authConfig.userIdCookie), 10);
    const token = this.cookies.get(this.authConfig.authHashCookie);
    this.next({ uid, token });
  }

  setState(uid: number, token: string) {
    this.cookies.put(this.authConfig.userIdCookie, uid.toString());
    this.cookies.put(this.authConfig.authHashCookie, token);
    this.next({ uid, token });
  }

  /*login(): Promise<void> {
    // TODO
  }

  logout(): Promise<void> {
    // TODO
    // this.next({});
  }*/
}



// WEBPACK FOOTER //
// ./src/app/@shared/auth/auth.service.ts